import type { Transaction } from "../client-ecommerce";

/** Prefer Stripe-settled currency for display (fixes legacy USD default rows). */
export function transactionDisplayCurrency(tx: Pick<Transaction, "currency"> & { metadata?: Record<string, unknown> }): string {
    const stripe = typeof tx.metadata?.stripe_currency === "string"
        ? tx.metadata.stripe_currency.toUpperCase()
        : null;
    return stripe || (tx.currency || "EUR").toUpperCase();
}

export function transactionDisplayAmount(tx: Pick<Transaction, "total_amount"> & { metadata?: Record<string, unknown> }): number {
    const received = tx.metadata?.stripe_amount_received;
    if (typeof received === "number" && received > 0) {
        return received / 100;
    }
    return Number(tx.total_amount) || 0;
}
